import React, { useContext } from 'react';
import { AuthContext } from '../../../../../../contexts/AuthContext';
import { formatMoney, formatNumber } from '../../../../../../utils/utils';
import ButtonTableAction from '../../../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../../../components/default/DefaultDataTable';
import { WarehouseQuoteStorage, WarehouseQuoteStorageFilters, WarehouseStorageDataForm } from '../../../../../../app/models/WareHouseQuoteStorage';

interface Props {
    warehouseQuoteStorages: WarehouseQuoteStorage[];
    totalRows: number;
    loading?: boolean;
    isShow?: boolean;
    edit?: (id: number) => void;
    destroy?: (id: number) => void;
    show?: (id: number) => void;
    filter: WarehouseQuoteStorageFilters;
    setFilter: (filter: WarehouseQuoteStorageFilters) => void;
    paginationRowsPerPageOptions?: any[];
}

const WarehouseStorageDataTable = ({
    warehouseQuoteStorages,
    totalRows,
    loading = false,
    edit,
    destroy,
    show,
    filter,
    setFilter,
    isShow = false,
}: Props) => {
    const { auth } = useContext(AuthContext);

    const columns = [



        {
            name: 'Almacén',
            selector: (row: any) => row.depot,
            sortable: true,
            sortField: 'depot',
            cell: (row: WarehouseStorageDataForm, index: any, column: any) => (
                <span className="">{row.depot}</span>

            //     <span className="">
            //     <div
            //         dangerouslySetInnerHTML={{
            //             __html: row.depot ? String(row.depot) : ''
            //         }}
            //     />
            // </span>

            )
        },
        {
            name: 'Días libres',
            selector: (row: any) => row.free_days,
            sortable: true,
            sortField: 'free_days',
            cell: (row: any) => formatNumber(row.free_days)
        },
        {
            name: 'Acciones',
            cell: (row: any) => (
                <div className="d-flex gap-1">
                    {show &&(
                        <ButtonTableAction
                            callbackFunction={() => show(row.id ?? -1)}
                            classIcon="mdi mdi-eye"
                            colorIcon="text-info"
                            title="Ver"
                        />
                    )}
                    {/* En modo “solo ver” (isShow=true) ocultamos el resto */}
                    {!isShow && edit && (
                        <ButtonTableAction
                        callbackFunction={() => edit(row.id ?? -1)}
                        classIcon="mdi mdi-pencil"
                        colorIcon="text-warning"
                        title="Editar"
                        />
                    )}
                    {!isShow && destroy && (
                        <ButtonTableAction
                        callbackFunction={() => destroy(row.id ?? -1)}
                        classIcon="mdi mdi-delete"
                        colorIcon="text-danger"
                        title="Eliminar"
                        />
                    )}
                    </div>
            )
        }
    ];

    return (
        <div className="row">
            <div className="col-12 mt-4">
                <DefaultDataTable
                    columns={columns}
                    data={warehouseQuoteStorages}
                    progressPending={loading}
                    filter={filter}
                    setFilter={setFilter}
                    paginationTotalRows={totalRows}
                />
            </div>
        </div>
    );
};

export default WarehouseStorageDataTable;
